"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Country = void 0;
const constants_1 = require("@daytrip/constants");
const legacy_enums_1 = require("@daytrip/legacy-enums");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const type_graphql_1 = require("type-graphql");
const typeorm_1 = require("typeorm");
const uuid_1 = require("uuid");
const CountryInvoiceInfo_1 = require("./CountryInvoiceInfo");
const LocalizedField_1 = require("./LocalizedField");
const VehicleTypeCosts_1 = require("./VehicleTypeCosts");
let Country = class Country {
    // We have to ensure its consistency across all DB instances as it's used as a cross-env unique identifier, example: packages/constants/src/countries.ts
    _id = (0, uuid_1.v4)();
    isoCode = "";
    continent = "";
    localName = "";
    englishName = "";
    timeZoneName = ""; // DEPRECATED
    countryGroup;
    roundtripGuideCoefficient = 1.5;
    roundtripMinimumCoefficient = 1.5;
    taxFeeCoefficient = 0;
    vehicleTypeCosts = [];
    googleTargetingId;
    currency;
    pricingCurrency = legacy_enums_1.Currency.Euro;
    isInSchengen;
    isPaymentCountry;
    bankType = legacy_enums_1.CountryBankType.IBAN;
    callingCode = "";
    emergencyPhone;
    applyTollPriceCoefficient = true;
    invoiceInfo = null;
    paymentProvider = legacy_enums_1.PaymentProvider.Mangopay;
    nameLocalized = new LocalizedField_1.LocalizedField();
    accomodationCost = constants_1.DEFAULT_ACCOMODATION_COST;
    comboDiscountCoefficient = 1;
    isInSepa = false;
};
exports.Country = Country;
__decorate([
    (0, type_graphql_1.Field)(),
    (0, typeorm_1.ObjectIdColumn)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Country.prototype, "_id", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.MaxLength)(16),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, type_graphql_1.Field)(),
    __metadata("design:type", String)
], Country.prototype, "isoCode", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.MaxLength)(16),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, type_graphql_1.Field)(),
    __metadata("design:type", String)
], Country.prototype, "continent", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.MaxLength)(64),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, type_graphql_1.Field)(),
    __metadata("design:type", String)
], Country.prototype, "localName", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.MaxLength)(64),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Country.prototype, "englishName", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.MaxLength)(64),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Country.prototype, "timeZoneName", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsInt)(),
    __metadata("design:type", Number)
], Country.prototype, "countryGroup", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Country.prototype, "roundtripGuideCoefficient", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Country.prototype, "roundtripMinimumCoefficient", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Country.prototype, "taxFeeCoefficient", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => VehicleTypeCosts_1.VehicleTypeCosts),
    (0, class_validator_1.ValidateNested)({ each: true }),
    __metadata("design:type", Array)
], Country.prototype, "vehicleTypeCosts", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], Country.prototype, "googleTargetingId", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsEnum)(legacy_enums_1.Currency),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Country.prototype, "currency", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsEnum)(legacy_enums_1.Currency),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], Country.prototype, "pricingCurrency", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], Country.prototype, "isInSchengen", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], Country.prototype, "isPaymentCountry", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsEnum)(legacy_enums_1.CountryBankType),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], Country.prototype, "bankType", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Country.prototype, "callingCode", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Country.prototype, "emergencyPhone", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], Country.prototype, "applyTollPriceCoefficient", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => CountryInvoiceInfo_1.CountryInvoiceInfo),
    __metadata("design:type", Object)
], Country.prototype, "invoiceInfo", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsEnum)(legacy_enums_1.PaymentProvider),
    __metadata("design:type", String)
], Country.prototype, "paymentProvider", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Type)(() => LocalizedField_1.LocalizedField),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", LocalizedField_1.LocalizedField)
], Country.prototype, "nameLocalized", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.Min)(constants_1.MIN_ACCOMODATION_COST),
    (0, class_validator_1.Max)(constants_1.MAX_ACCOMODATION_COST),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)()
    // In case when accomodation cost is not specified during country setup, default to low value that will be spotted in combo acceptance rate
    ,
    __metadata("design:type", Number)
], Country.prototype, "accomodationCost", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(constants_1.MIN_COMBO_DISCOUNT_COEFFICIENT),
    (0, class_validator_1.Max)(constants_1.MAX_COMBO_DISCOUNT_COEFFICIENT),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Country.prototype, "comboDiscountCoefficient", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], Country.prototype, "isInSepa", void 0);
exports.Country = Country = __decorate([
    (0, typeorm_1.Entity)("countries"),
    (0, type_graphql_1.ObjectType)("Country"),
    (0, type_graphql_1.InputType)("CountryInput")
], Country);
//# sourceMappingURL=Country.js.map